import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { convertToUpperCase } from 'helper';

function RequestorInformation({
  taxpayer,
  transactionInfo,
}) {
  const spanGap = 8;
  const regionName = _.get(taxpayer, 'mailing_address_region_name') || _.get(taxpayer, 'region_name') || '--';
  const provinceName = _.get(taxpayer, 'mailing_address_province_name') || _.get(taxpayer, 'province_name') || '--';
  const municipalityName = _.get(taxpayer, 'mailing_address_municipality_name') || _.get(taxpayer, 'municipality_name') || '--';
  const barangayName = _.get(taxpayer, 'mailing_address_barangay_name') || _.get(taxpayer, 'barangay_name') || '--';
  const streetName = _.get(taxpayer, 'mailing_address_street') || _.get(taxpayer, 'street') || '--';
  const zipCodeName = _.get(taxpayer, 'mailing_zip_code') || '--';

  return (
    <>
      <div className='p-3' style={{ maxHeight: '700px', overflowY: 'scroll' }}>
        <table className="transaction-table table table-borderless table-sm">
          <tbody>
            <tr className='mt-3'>
              <td width="350">
                <span className="title" style={{ fontSize: '16px' }}>
                  REQUESTOR'S INFORMATION
                </span>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                First Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {convertToUpperCase(_.get(taxpayer, 'requestors_first_name'))}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Middle Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {convertToUpperCase(_.get(taxpayer, 'requestors_middle_name'))}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Last Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {convertToUpperCase(_.get(taxpayer, 'requestors_last_name'))}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Extension Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {convertToUpperCase(_.get(taxpayer, 'requestors_suffix_name'))}
                </b>
              </td>
            </tr>

            <tr className='mt-3'>
              <td width="350">
                <span className="title" style={{ fontSize: '16px' }}>
                  CONTACT INFORMATION
                </span>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Mailing Address
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {`
                    ${streetName || '--'}, 
                    ${barangayName || '--'}, 
                    ${municipalityName || '--'}, 
                    ${provinceName || '--'}, 
                    ${regionName || '--'}, 
                    ${zipCodeName || '--'}
                  `}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Telephone Number
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {_.get(taxpayer, 'telephone_number') || _.get(transactionInfo, 'attributes.telephone_number') || '--'}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Mobile Number
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {_.get(taxpayer, 'mobile_number') || _.get(transactionInfo, 'attributes.mobile_number') || '--'}
                </b>
              </td>
            </tr>

            <tr className='mt-3'>
              <td width="350">
                <span className="title" style={{ fontSize: '16px' }}>
                  OTHER INFORMATION
                </span>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Relationship to the owner
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {convertToUpperCase(_.get(taxpayer, 'relationship_to_the_owner'))}
                </b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}

RequestorInformation.defaultProps = {
  taxpayer: {},
  transactionInfo: {},
};

RequestorInformation.propTypes = {
  taxpayer: PropTypes.instanceOf(Object),
  transactionInfo: PropTypes.instanceOf(Object),
};

export default RequestorInformation;
